import { isEmpty, isNaN } from "lodash-es";

export const isNumber = (val) => {
  let result = false;
  if (isNaN(Number(val)) || !val) {
    result = false;
  } else {
    result = true;
  }
  return isEmpty(val) || result;
};

export const restoreNumber = (val) => {
  if (!val) return val
  const _val = String(val)
  return _val.replace(/[^0-9]/g, "")
}

export const transformNumber = restoreNumber
